import styled, { css, keyframes } from "styled-components";
import { getPropertyByMedia } from "../helpers";
const skeletonKeyframes = keyframes `
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;
export const Container = styled.span `
	--temp-gray: #e7e7e7;

	display: block;
	position: relative;

	border-radius: 8px;
	background-color: var(--temp-gray);

	${({ margin }) => getPropertyByMedia("margin", margin)};
	${({ padding }) => getPropertyByMedia("padding", padding)};

	${({ width }) => getPropertyByMedia("width", width)};
	${({ height }) => getPropertyByMedia("height", height)};
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth)};
	${({ zIndex }) => getPropertyByMedia("z-index", zIndex)};
	${({ display }) => getPropertyByMedia("display", display)};
	aspect-ratio: initial;
	overflow: hidden;

	${({ type, height }) => type === "circle" &&
    css `
			border-radius: 100%;

			height: ${height || "20px"};
			width: ${height || "20px"};
			aspect-ratio: '1/1';
		`};

	div {
		position: absolute;

		background: linear-gradient(
			90deg,
			var(--semantic-disable-weak),
			var(--surface-white) 90%,
			var(--semantic-disable-weak) 100%
		);
		width: 100%;
		height: 100%;

		animation: ${skeletonKeyframes} 1000ms ease-in-out infinite;
	}
`;
//# sourceMappingURL=styles.js.map